import { observer } from "mobx-react-lite";
import React from 'react'

export const Playlist = observer(() => (
  <div>Playlist</div>
));